module.exports = __webpack_public_path__ + "img/gauge-simple-low.a97d10fe.svg";